import * as _ from "lodash-es";
import { ChangeEvent, Component } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import IBulkOrderImportProgressDTO from "@models/DTO/IBulkOrderImportProgressDTO";
import IDeleteBatchOrdersDTO from "@models/DTO/IDeleteBatchOrdersDTO";
import IErrorDTO from "@models/DTO/IErrorDTO";
import IGetBatchOrdersDTO from "@models/DTO/IGetBatchOrdersDTO";
import IGetBulkImportQueueDTO from "@models/DTO/IGetBulkImportQueueDTO";
import IGetOrderBatchPdfDTO from "@models/DTO/IGetOrderBatchPdfDTO";
import IOnDeleteBatchOrdersDTO from "@models/DTO/IOnDeleteBatchOrdersDTO";
import IOnGetBatchOrdersDTO from "@models/DTO/IOnGetBatchOrdersDTO";
import IOnGetBulkImportQueueDTO from "@models/DTO/IOnGetBulkImportQueueDTO";
import IOnGetOrderBatchPdfDTO from "@models/DTO/IOnGetOrderBatchPdfDTO";
import IUserLeaveRoomDTO from "@models/DTO/IUserLeaveRoomDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import IBreadcrumbs from "@models/IBreadcrumbs";
import IBulk_Import_Queue from "@models/IBulk_Import_Queue";
import INotification from "@models/INotification";
import IOrder from "@models/IOrder";
import IOrder_Batch from "@models/IOrder_Batch";
import IOwTableCols from "@models/IOwTableCols";
import ISupplierModel from "@models/ISupplierModel";
import IUserUI from "@models/IUserUI";
import NotificationLevelEnum from "@models/NotificationLevelEnum";
import NotificationPositionEnum from "@models/NotificationPositionEnum";
import OrderStatesEnum from "@models/OrderStatesEnum";
import UIService from "@services/UIService";
import Breadcrumbs from "@components/shared/Breadcrumbs/Breadcrumbs";
import OwButton from "@components/shared/OwButton/OwButton";
import OwCheckbox from "@components/shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "@components/shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTable from "@components/shared/OwTable/OwTable";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import PaginationBar from "@components/shared/PaginationBar/PaginationBar";
import BulkOrderSubmitModal from "@components/orders/BulkOrderSubmitModal/BulkOrderSubmitModal";
import "./BatchOrders.scss";
import { Socket } from "socket.io-client";
import { ConfirmDeleteOverlayFn } from "@components/shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "@components/shared/OwDeleteEditActions/OwDeleteEditActions";
import { SearchSection } from "@components/shared/SearchSection/SearchSection";
import IUiSocketSetup from "@models/IUiSocketSetup";
import { BulkOrderSubmitFnModal } from "@components/orders/BulkOrderSubmitFnModal/BulkOrderSubmitFnModal";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    history: any;
    location: any;
};

type State = {
    crumbs: IBreadcrumbs[];
    batchOrders: IOrder_Batch[];
    columns: IOwTableCols[];
    detailViewColumns: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
    offset: number;
    limit: number;
    totalBatchOrders: number;
    modalIsOpen: boolean;
    modalComponent: any;
    order: string;
    batch: string;
    hide_shipped: boolean;
    scanMode: boolean;
    capturedScanValue: string;
    deleteRowElem: string | null;
    deleteRow?: IOrder_Batch;
    isVisible: boolean;
    enterOrderOnSearch: boolean;
    bulkImportQueue: IBulk_Import_Queue[];
    bulkImportProgress?: IBulkOrderImportProgressDTO;
};

class BatchOrders extends Component<Props, State> {
    overlayRef: any = null;

    constructor(props: any) {
        super(props);

        this.state = {
            batchOrders: [],
            columns: [
                {
                    hasChevron: true,
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderActionsCol,
                    renderFnEmitsRow: true,
                },
                {
                    title: "batch_no",
                    valueProp: "batch_no",
                },
                {
                    title: "shipment_batch_no",
                    valueProp: "Shipment_Batch",
                    valueSubProp: "batch_no",
                },
                {
                    title: "batch_step",
                    valueProp: "",
                    renderFn: this.renderBatchStepCol,
                    renderFnEmitsRow: true,
                },
                {
                    title: "total_rows",
                    valueProp: "total_rows",
                },
                {
                    title: "total_orders",
                    valueProp: "total_created",
                },
                {
                    title: "total_errored",
                    valueProp: "total_errored",
                    renderFn: this.renderTotalErrored,
                },
            ],
            detailViewColumns: [
                {
                    title: "order",
                    valueProp: "name",
                    renderFn: this.renderOrderCol,
                    renderFnEmitsRow: true,
                    className: "min-w-10r w-15r no-wrap",
                },
                {
                    title: "status",
                    valueProp: "Order_State",
                    valueSubProp: "name",
                    renderFn: this.renderOrderState,
                    renderFnEmitsRow: true,
                    className: "w-10r",
                },
                {
                    title: "vendor",
                    isVendorOverride: true,
                    valueProp: "Vendor",
                    valueSubProp: "name",
                    className: "w-15r",
                },
                {
                    title: "user",
                    valueProp: "User",
                    valueSubProp: "name",
                },
            ],
            isDataFetching: false,
            isInitialData: true,
            crumbs: [
                {
                    title: "orders",
                    url: "/orders",
                },
                {
                    title: "batch",
                    url: "/batch",
                },
            ],
            offset: 0,
            limit: 25,
            totalBatchOrders: 0,
            modalIsOpen: false,
            modalComponent: null,
            order: "",
            batch: "",
            hide_shipped: true,
            scanMode: false,
            capturedScanValue: "",
            isVisible: true,
            enterOrderOnSearch: false,
            bulkImportQueue: [],
            deleteRowElem: null,
        };

        document.title = `Orderwerks >> Orders >> Batch`;

        this.sockets = [
            { endpoint: EndpointsEnum.OrderOnGetBatchOrders, fn: this.onGetBatchOrders },
            { endpoint: EndpointsEnum.OrderOnDeleteBatchOrders, fn: this.onDeleteBatchOrders },
            { endpoint: EndpointsEnum.OrderOnGetOrderBatchPDF, fn: this.onGetOrderBatchPdf },
            { endpoint: EndpointsEnum.OrderOnGetBulkImportQueue, fn: this.onGetBulkImportQueue },
            { endpoint: `${this.props.supplierModel.guid}/batchOrdersProgress` as EndpointsEnum, fn: this.bulkImportProgress },
        ];
    }

    sockets: IUiSocketSetup[] = [];

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        document.addEventListener("keydown", this.keyboardListener);

        this.getBatchOrders();
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }

        document.removeEventListener("keydown", this.keyboardListener);

        const payload: IUserLeaveRoomDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            roomName: `${this.props.supplierModel.guid}/batchOrdersProgress`,
        };

        this.props.socket.emit(EndpointsEnum.UserLeaveRoom, payload);
    }

    keyboardListener = (e: KeyboardEvent) => {
        if (this.state.scanMode) {
            console.log("keyboardListener: ", e);
            // ignore the following key events
            switch (e.key) {
                case "Shift":
                case "Unidentified":
                    return;

                case "Enter":
                    this.processCapturedScanValue();
                    return;
            }

            this.setState({
                capturedScanValue: `${this.state.capturedScanValue}${e.key}`,
            });
        }
    };

    getBulkImportQueue = () => {
        const payload: IGetBulkImportQueueDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            includeAll: false,
        };

        this.props.socket.emit(EndpointsEnum.OrderGetBulkImportQueue, payload);
    };

    onGetBulkImportQueue = (data: IOnGetBulkImportQueueDTO) => {
        this.setState({
            bulkImportQueue: data.bulkImportQueue,
        });
    };

    bulkImportProgress = (data: IBulkOrderImportProgressDTO) => {
        this.setState(
            {
                bulkImportProgress: data,
            },
            () => {
                if (data.completed) {
                    this.getBulkImportQueue();
                }
            }
        );
    };

    processCapturedScanValue = () => {
        const capturedScanValue = this.state.capturedScanValue;

        if (capturedScanValue.indexOf("scan-") === 0) {
            // process the scan
            const scanDetail = capturedScanValue.substr(5, capturedScanValue.length);

            // process a command?
            const scanCommand = "";

            let orderName = "";
            let batchNo = "";

            let enterOrderOnSearch = false;

            // process the scan guid now
            if (scanDetail.indexOf("batch-") === 0) {
                batchNo = scanDetail.substr(6, capturedScanValue.length);
            } else {
                orderName = scanDetail;
                enterOrderOnSearch = true;
            }

            this.setState(
                {
                    capturedScanValue: "",
                    order: orderName,
                    batch: batchNo,
                    enterOrderOnSearch,
                },
                () => {
                    const notification: INotification = {
                        message: "scan_captured",
                        level: NotificationLevelEnum.success,
                        position: NotificationPositionEnum.bc,
                    };

                    this.props.notifyFn(null, notification);

                    this.search();
                }
            );
        } else {
            // error processing the captured scan value

            const notification: INotification = {
                message: "error_capturing_scan",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        }
    };

    buildQueryString = (): string => {
        const query: string[] = [];

        if (!_.isNil(this.state.hide_shipped) && this.state.hide_shipped) {
            query.push(`hide_shipped=true`);
        }

        if (!_.isNil(this.state.order) && this.state.order.length) {
            query.push(`order=${this.state.order}`);
        }

        if (!_.isNil(this.state.batch) && this.state.batch.length) {
            query.push(`batch=${this.state.batch}`);
        }

        let queryString = "";

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        return queryString;
    };

    getBatchOrders = () => {
        const payload: IGetBatchOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            limit: this.state.limit,
            offset: this.state.offset,
            removeOrders: true,
        };

        const queryString = this.buildQueryString();

        if (queryString.length) {
            payload.queryString = queryString;
        }

        this.props.socket.emit(EndpointsEnum.OrderGetBatchOrders, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetBatchOrders = (data: IOnGetBatchOrdersDTO) => {
        if (this.state.enterOrderOnSearch) {
            let foundOrder: IOrder | undefined;

            for (const batchOrder of data.batchOrders) {
                if (batchOrder.Orders) {
                    for (const order of batchOrder.Orders) {
                        if (order.name === this.state.order) {
                            foundOrder = order;
                        }
                    }
                }
            }

            if (foundOrder) {
                const url = `/orders/${foundOrder.guid}/entry`;
                this.props.history(url);
            }
        } else {
            let batchOrders = this.state.batchOrders;

            if (data.isOrderRetrieval) {
                const batchOrderOrdersIncl = data.batchOrders[0];

                for (const batchOrder of batchOrders) {
                    if (batchOrder.guid === batchOrderOrdersIncl.guid) {
                        batchOrder.Orders = batchOrderOrdersIncl.Orders;
                    }
                }
            } else {
                batchOrders = data.batchOrders;
            }

            console.log("batchOrders: ", batchOrders);

            this.setState({
                batchOrders,
                totalBatchOrders: data.totalBatchOrders,
                isDataFetching: false,
                isInitialData: false,
                bulkImportQueue: data.bulkImportQueue,
            });
        }
    };

    getBatchOrderOrders = (batch: IOrder_Batch) => {
        const payload: IGetBatchOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            removeOrders: false,
            queryString: `batch=${batch.batch_no}`,
            isOrderRetrieval: true,
        };

        this.props.socket.emit(EndpointsEnum.OrderGetBatchOrders, payload);
    };

    onDeleteBatchOrders = (data: IOnDeleteBatchOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_batch_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.getBatchOrders();
    };

    batchSubmit = (row: IOrder_Batch) => {
        const orderGuids: string[] = (row.Orders || []).map((order) => {
            return order.guid;
        });

        const component = (
            <BulkOrderSubmitModal
                selectAll={false}
                orderBatch={row}
                orderGuids={orderGuids}
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
            />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent: component,
        });
    };

    batchSubmitFn = (row: IOrder_Batch) => {
        const orderGuids: string[] = (row.Orders || []).map((order) => {
            return order.guid;
        });

        const component = (
            <BulkOrderSubmitFnModal selectAll={false} orderBatch={row} orderGuids={orderGuids} closeModalFn={this.closeModal} />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent: component,
        });
    };

    onPaginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                isDataFetching: true,
                offset,
                limit,
            },
            () => {
                this.getBatchOrders();
            }
        );
    };

    confirmDeleteBatch = (row: IOrder_Batch, index: number) => {
        const deleteRowElem = `row-${index}`;

        this.setState({
            deleteRowElem,
            deleteRow: row,
        });
    };

    cancelDelete = () => {
        this.setState({
            deleteRowElem: null,
            deleteRow: undefined,
        });
    };

    commitDelete = () => {
        if (this.state.deleteRow) {
            const payload: IDeleteBatchOrdersDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                batchGuid: this.state.deleteRow.guid,
            };

            this.props.socket.emit(EndpointsEnum.OrderDeleteBatchOrders, payload);

            this.setState({
                deleteRowElem: null,
                deleteRow: undefined,
            });
        }
    };

    downloadBatchPdf = (row: IOrder_Batch) => {
        const payload: IGetOrderBatchPdfDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderBatchGuid: row.guid,
        };

        this.props.socket.emit(EndpointsEnum.OrderGetOrderBatchPDF, payload);
    };

    onGetOrderBatchPdf = (data: IOnGetOrderBatchPdfDTO) => {
        const blob = new Blob([data.pdfData], { type: "application/pdf" }); // change resultByte to bytes

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const fileName = data.filename;

        link.download = _.get(this.props, "fileName", `${fileName}.pdf`);
        link.click();
    };

    isBatchAllShipped = (index: number): boolean => {
        let isBatchAllShipped = true;

        const orderBatch = this.state.batchOrders[index];

        if (orderBatch.Orders) {
            for (const row of orderBatch.Orders) {
                if (row.order_state_id !== OrderStatesEnum.SHIPPED) {
                    isBatchAllShipped = false;
                    break;
                }
            }
        }

        return isBatchAllShipped;
    };

    renderActionsCol = (row: IOrder_Batch, index: number) => {
        if (row.Orders && row.Orders.length) {
            const isBatchAllShipped = this.isBatchAllShipped(index);

            if (isBatchAllShipped) {
                return null;
            } else {
                return (
                    <div className={"d-flex no-wrap"}>
                        <OwDeleteEditActions
                            isEditMode={false}
                            onTrashClickFn={() => {
                                this.confirmDeleteBatch(row, index);
                            }}
                            onEditClickFn={() => {}}
                            hideEdit={true}
                            className={"ms-2"}
                        />

                        {/* <OwButton
                            className={"ms-2 btn-primary btn-sm mb-5 mb-md-0 mt-5 mt-md-0 no-wrap"}
                            leftIconClass={"fad fa-arrow-circle-right"}
                            title={"batch_submit"}
                            fn={() => {
                                this.batchSubmit(row);
                            }}
                        /> */}

                        <OwButton
                            className={"ms-2 btn-primary btn-sm mb-5 mb-md-0 mt-5 mt-md-0 no-wrap"}
                            leftIconClass={"fad fa-arrow-circle-right"}
                            title={"batch_submit"}
                            fn={() => {
                                this.batchSubmitFn(row);
                            }}
                        />

                        <OwButton
                            className={"ms-2 btn-primary"}
                            leftIconClass={"fad fa-download"}
                            title={"download_pdf"}
                            fn={() => {
                                this.downloadBatchPdf(row);
                            }}
                        />
                    </div>
                );
            }
        } else {
            return (
                <div className={"no-wrap"}>
                    <OwDeleteEditActions
                        isEditMode={false}
                        onTrashClickFn={() => {
                            this.confirmDeleteBatch(row, index);
                        }}
                        onEditClickFn={() => {}}
                        hideEdit={true}
                        className={"ms-2"}
                    />
                </div>
            );
        }
    };

    renderBatchStepCol = (row: IOrder_Batch) => {
        if (row.Orders && row.Orders.length) {
            const rowFirstOrder: IOrder = row.Orders[0];

            let orderState = rowFirstOrder.Order_State?.name.toLowerCase() || "--";

            for (const order of row.Orders) {
                if (order.order_state_id !== rowFirstOrder.order_state_id) {
                    orderState = "--";
                    break;
                }
            }

            if (orderState === "--") {
                return orderState;
            } else {
                return <OwLabel title={rowFirstOrder.Order_State?.name.toLowerCase() || ""} noBottomMargin={true} />;
            }
        } else {
            return "--";
        }
    };

    renderOrderCol = (row: IOrder, index: number) => {
        return (
            <div>
                <span className={"me-2"}>{++index})</span>
                <Link to={`/orders/${row.guid}/entry`}>{row.name}</Link>
            </div>
        );
    };

    renderOrderState = (row: IOrder) => {
        const orderState = row.Order_State!.name.toLowerCase();
        return <OwLabel title={orderState} noBottomMargin={true} />;
    };

    renderTotalErrored = (totalErrored: number) => {
        if (totalErrored) {
            return totalErrored;
        } else {
            return "--";
        }
    };

    afterOpenModal = () => {};

    closeModal = (refreshData?: boolean) => {
        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                if (refreshData) {
                    this.getBatchOrders();
                }
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    search = () => {
        this.setState(
            {
                limit: 25,
                offset: 0,
            },
            () => {
                this.getBatchOrders();
            }
        );
    };

    resetSearch = () => {
        this.setState(
            {
                order: "",
                hide_shipped: true,
            },
            () => {
                this.getBatchOrders();
            }
        );
    };

    toggleScanMode = () => {
        this.setState({
            scanMode: !this.state.scanMode,
        });
    };

    toggleVisible = () => {
        this.setState({
            isVisible: !this.state.isVisible,
        });
    };

    enterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.search();
        }
    };

    renderQueueStatus = (row: IBulk_Import_Queue) => {
        let progressDetail = ``;

        let queueStatus = row.Queue_Status!.name.toLowerCase();

        if (row.guid === this.state.bulkImportProgress?.bulkOrderImportGuid) {
            progressDetail = ` ${this.state.bulkImportProgress.totalProcessed} / ${this.state.bulkImportProgress.totalItems}`;
            queueStatus = `processing`;
        }

        return (
            <div>
                <OwLabel title={queueStatus} />
                {progressDetail}
            </div>
        );
    };

    toggleOpenOrderBatch = (row: number, detailViewOpen: boolean) => {
        console.log("Toggle Open Order Batch: ", row, detailViewOpen);

        if (detailViewOpen) {
            const batch = this.state.batchOrders[row];

            this.getBatchOrderOrders(batch);
        }
    };

    render() {
        let cardClass = "dark-card text-white bg-secondary";

        if (UIService.isMainViewLight()) {
            cardClass = "";
        }

        return (
            <div className="BatchOrders position-relative">
                <Breadcrumbs crumbs={this.state.crumbs} />

                <div className="row mt-2">
                    <div className={"col-12 d-flex align-items-center"}>
                        <OwTitle title={"batch_orders"} leftIconName={"fad fa-conveyor-belt-alt"} />
                        <div className={"d-flex flex-column ms-auto"}>
                            <div>
                                <OwLabel title={"scan_mode"} />
                            </div>
                            <OwToggle fn={this.toggleScanMode} name={"scan_mode"} label={""} active={this.state.scanMode} />
                        </div>
                    </div>
                </div>

                <div className={"row mt-2 mb-3"}>
                    <div className={"col-12 " + (this.state.isVisible ? "" : "d-none")}>
                        <SearchSection>
                            <div className={"row d-flex align-items-end"}>
                                <div className={"col-12 col-md-2 mb-4 mb-md-0"}>
                                    <OwLabel title={"order"} />
                                    <div>
                                        <OwInputWrapper
                                            name={"order"}
                                            fn={this.handleChange}
                                            value={this.state.order}
                                            onKeyDownFn={this.enterSearch}
                                        />
                                    </div>
                                </div>

                                <div className={"col-12 col-md-2 mb-4 mb-md-0"}>
                                    <OwLabel title={"batch"} />
                                    <div>
                                        <OwInputWrapper
                                            name={"batch"}
                                            fn={this.handleChange}
                                            value={this.state.batch}
                                            onKeyDownFn={this.enterSearch}
                                        />
                                    </div>
                                </div>

                                <div className={"col-12 col-md-2 mb-4 mb-md-0"}>
                                    <div>
                                        <OwCheckbox
                                            name={"hide_shipped"}
                                            label={"hide_shipped"}
                                            fn={this.handleChange}
                                            checked={this.state.hide_shipped}
                                            truthyVal={true}
                                            falsyVal={false}
                                        />
                                    </div>
                                </div>

                                <div className={"col"}>
                                    <OwButton
                                        title={"search"}
                                        fn={this.search}
                                        disabled={this.state.isDataFetching}
                                        disableOnActive={true}
                                    />
                                    <OwButton
                                        title={"reset"}
                                        fn={this.resetSearch}
                                        className={"btn-danger ms-2"}
                                        disabled={this.state.isDataFetching}
                                        disableOnActive={true}
                                    />
                                </div>
                            </div>
                        </SearchSection>
                    </div>
                </div>

                {this.state.bulkImportQueue.length ? (
                    <div>
                        <OwTitle title={"bulk_import_queue"} tag={"h5"} />
                        <OwTable
                            columns={[
                                {
                                    title: "no",
                                    valueProp: "",
                                    renderFn: (value: any, index: number) => {
                                        return `# ${++index}`;
                                    },
                                    className: "w-5r",
                                },
                                {
                                    title: "status",
                                    valueProp: "Queue_Status",
                                    valueSubProp: "name",
                                    renderFn: this.renderQueueStatus,
                                    renderFnEmitsRow: true,
                                },
                            ]}
                            dataSet={this.state.bulkImportQueue}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={false}
                            initialData={false}
                        />
                    </div>
                ) : null}

                <div className={"position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.deleteRowElem}
                        handleConfirm={this.commitDelete}
                        handleCancel={this.cancelDelete}
                        leftAdjustment={0}
                        nestedParentElem={"batch-orders-table"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"batch-orders-table"}
                        columns={this.state.columns}
                        detailViewDataSet={this.state.batchOrders}
                        detailViewDataSetProp={"Orders"}
                        isDetailViewTable={true}
                        chevronToggleCallbackFn={this.toggleOpenOrderBatch}
                        tableConfig={{ hasDetailView: true, tableStriped: true }}
                        detailViewColumns={this.state.detailViewColumns}
                        dataSet={this.state.batchOrders}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                    />
                </div>

                <div>
                    <PaginationBar
                        offset={this.state.offset}
                        limit={this.state.limit}
                        totalRecords={this.state.totalBatchOrders}
                        onPaginationChanged={this.onPaginationChanged}
                    />
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={(e: any) => {
                            this.closeModal();
                        }}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}
                        style={{}}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default BatchOrders;
